module.exports = __webpack_public_path__ + "static/media/background.2fc3a7bb.jpg";